import { createSlice } from '@reduxjs/toolkit';
import { initialViewState } from 'store/initialStateSlice';
import { WebMercatorViewport } from '@deck.gl/core';
import regionPhilippines from 'data/admin/philippines/region';
import provincePhilippines from 'data/admin/philippines/province';
import citymunPhilippines from 'data/admin/philippines/municipality';
import { setViewState as _setViewState } from '@carto/react-redux';

import regionIndonesia from 'data/admin/indonesia/region';
import provinceIndonesia from 'data/admin/indonesia/province';
import citymunIndonesia from 'data/admin/indonesia/municipality';

const slice = createSlice({
  name: 'app',
  initialState: {
    error: null,
    bottomSheetOpen: false,
    regionFilters: {
      country: '',
      region: '',
      province: '',
      citymun: '',
    },
    adminBoundarySelect: {
      country: '',
      region: '',
      province: '',
      citymun: '',
    },
    mapHighlight: {
      layer: null,
      id: null,
      properties: null,
    },
    selected: [],
    lassoEnabled: false,
    suitabilityFilters: {
      suitable: false,
      unsuitable: false,
      highlyUnsuitable: false,
    },
  },
  reducers: {
    setError: (state, action) => {
      state.error = action.payload;
    },
    setBottomSheetOpen: (state, action) => {
      state.bottomSheetOpen = action.payload;
    },
    setRegionFilters: (state, action) => {
      state.regionFilters = action.payload;
    },
    setMapHighlight: (state, action) => {
      state.mapHighlight = action.payload;
    },
    setAdminBoundarySelect: (state, action) => {
      state.adminBoundarySelect = action.payload;
    },
    setLassoEnabled: (state, action) => {
      state.lassoEnabled = action.payload;
    },
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setSuitabilityFilters: (state, action) => {
      state.suitabilityFilters = action.payload;
    },
  },
});

export default slice.reducer;

export const setError = (payload) => ({ type: 'app/setError', payload });
export const setBottomSheetOpen = (payload) => ({
  type: 'app/setBottomSheetOpen',
  payload,
});

export const setRegionFilters = (payload) => ({
  type: 'app/setRegionFilters',
  payload,
});

export const setMapHighlight = (payload) => ({
  type: 'app/setMapHighlight',
  payload,
});

export const setAdminBoundarySelect = (payload) => ({
  type: 'app/setAdminBoundarySelect',
  payload,
});
export const setLassoEnabled = (payload) => ({
  type: 'app/setLassoEnabled',
  payload,
});
export const setSelected = (payload) => ({
  type: 'app/setSelected',
  payload,
});
export const setSuitabilityFilters = (payload) => ({
  type: 'app/setSuitabilityFilters',
  payload,
});

export const setViewState = (payload, currentViewState) => {
  const { country, province, region, citymun } = payload;
  let citymunArea;
  let provinceArea;
  let regionArea;
  let bbox;
  let viewState = { ...initialViewState };
  switch (country) {
    case 'PH':
      citymunArea = citymunPhilippines;
      provinceArea = provincePhilippines;
      regionArea = regionPhilippines;
      break;
    case 'ID':
      citymunArea = citymunIndonesia;
      provinceArea = provinceIndonesia;
      regionArea = regionIndonesia;
      break;
    default:
      citymunArea = {};
      provinceArea = {};
      regionArea = [];
  }
  if (citymun) {
    bbox = citymunArea[province].find((f) => f.value === citymun).bbox;
  } else if (province) {
    bbox = provinceArea[region].find((f) => f.value === province).bbox;
  } else if (region) {
    bbox = regionArea.find((f) => f.value === region).bbox;
  } else if (country) {
    switch (country) {
      case 'PH':
        viewState = {
          latitude: 12.606265640798826,
          longitude: 123.2936815486843,
          zoom: 5.2,
          transitionDuration: 1000,
        };
        break;
      case 'ID':
        viewState = {
          longitude: 111.00329378202397,
          latitude: -0.3132123328869895,
          zoom: 5,
          transitionDuration: 1000,
        };
        break;
      default:
        break;
    }
  }

  if (bbox) {
    const { longitude, latitude, zoom } = new WebMercatorViewport(
      currentViewState
    ).fitBounds([bbox.slice(2, 4), bbox.slice(0, 2)]);
    viewState = { latitude, longitude, zoom, transitionDuration: 2000 };
  }

  return _setViewState(viewState);
};

export const setViewStateByBbox = (payload, currentViewState) => {
  const bbox = payload;
  const { longitude, latitude, zoom } = new WebMercatorViewport(
    currentViewState
  ).fitBounds([bbox.slice(2, 4), bbox.slice(0, 2)], { maxZoom: 18, padding: 100 });
  const viewState = { latitude, longitude, zoom, transitionDuration: 2000 };
  return _setViewState(viewState);
};
